<script>
    import { onMount, createEventDispatcher } from 'svelte'


    import axios from 'axios'
    import AdminLayout from '../../layouts/AdminLayout.svelte'
    import Sidepanel from '../../components/Sidepanel/Sidepanel.svelte'
    import UsersSideContent from './UsersSideContent.svelte'
    import FadeinFX from '../../components/FX/FadeinFx.svelte'
    import UserItem from './UserItem.svelte'
    import UserEditor from './UserEditor.svelte'
    import wait from '../../libs/wait'
    import { background, notifySuccess } from '../../components/Notifications/AppNotifications.svelte'

    export let id
    export let admin = false

    const dispatch = createEventDispatcher ();
    
    let screenReady     = false,
        model           = [],
        searchQuery     = '',
        editingActive   = false,
        editingUser     = null;
        

    
    const onSearch = (event) => {
        // console.log ('onSearch', event.detail)
        searchQuery = event.detail
    }

    const onDisableUser = event => {
        const { resolve, reject, bean } = event.detail
        background (true);
        axios.request ({
            method: 'POST',
            url: `/api/users/toggleDisabled`,
            params: {
                id: bean.token_id,
                disabled: !bean.disabled
            }
        }).then (() => {
            wait(200).then(() => {
                background (false)
                const editing = model.find (it => it.token_id === bean.token_id);
                if (editing) {
                    editing.disabled = !editing.disabled;
                    model = model;
                }
                resolve ()
            })
        }).catch (reject);
    }

    const onEditUser = event => {
        editingUser = event.detail.bean;
        editingActive = true;
    }

    const onUserCreate = (event) => {
        editingUser = null;
        editingActive = true;
    }

    const onEditingCancel = event => {
        editingActive = false;
        editingUser = null;
    }

    const onEditingSave = event => {
        const { data, create } = event.detail
        // console.log ('onEditingSave', data, create);
        background (true);
        editingActive = false;
        editingUser = null;
        axios.request ({
            method: 'POST',
            url: '/api/users/save',
            data
        }).then (() => {
            background (false);
            notifySuccess ('Modifiche salvate.');
            fetchModel ();
        })
    }

    const onSendCredentials = event => {
        const { data, resolve, reject } = event.detail

        // console.log ('send credentials', data)
        axios.request ({
            method: 'POST',
            url: '/api/users/requestCredentials',
            params: {
                id: data.token_id
            }
        }).then (() => {
            notifySuccess ('Credenziali inviate.');
            resolve ();
        }).catch (reject)
    }

    const onDeleteUser = event => {
        const { token_id } = event.detail.bean
        background (true);
        axios.request ({
            method: 'POST',
            url: `/api/users/delete`,
            params: {
                id: token_id
            }
        }).then (() => {
            notifySuccess ('Utente eliminato.');
            fetchModel ();
        })
    }

    const fetchModel = async () => {
        background (true);
        axios.get (`/api/users/listBySector/${id}`)
            .then (result => {
                model = result.data
                    .sort ((a, b) => a.username > b.username ? 1 : -1)
                    .filter (it => admin ? true : it.role !== 0)
                screenReady = true
                background (false);
            }).catch (e => {
                background (false);
                dispatch ('app-event', { id: 'app-error', error: e });
                screenReady = true    
            })
    }

    $: {
        fetchModel (id)
    }

    $: filtered = searchQuery.length ? 
        model.filter (it => it.name.toLowerCase().includes(searchQuery) || it.username.toLowerCase().includes(searchQuery)) : model;
</script>


<Sidepanel>
    <UsersSideContent on:search={onSearch} on:create={onUserCreate} />
</Sidepanel>
<AdminLayout classes="sidepanel">
    <div class="page-pad avoid-selection">
        {#if screenReady}
            <FadeinFX delay={300} delayOut={0}>
                {#each filtered as user (user.token_id)}
                    <UserItem data={user} on:edit={onEditUser} on:disable={onDisableUser} on:delete={onDeleteUser} />
                {:else}
                    <div class="no-results-item">Nessun risultato trovato</div>
                {/each}
            </FadeinFX>
        {/if}
    </div>
</AdminLayout>

{#if editingActive}
    <UserEditor data={editingUser} create={editingUser === null} {admin} on:credentials={onSendCredentials} on:cancel={onEditingCancel} on:save={onEditingSave} />
{/if}


<style>
    
</style>